import { MENU_VALUES } from '@API/workspace';
import { MenuOption } from '../WorkspaceCard.type';

export const checkIsWithCollaborators = (membersCount: number): boolean =>
  membersCount >= 1;

export const generateTooltipForSetDefault = ({
  isMember,
  isDefault
}: {
  isMember: boolean;
  isDefault: boolean;
}): string => {
  if (!isMember) {
    return `Only members of a workspace can assign it as default`;
  }

  if (isDefault) {
    return 'Workspace is already marked as Default';
  }

  return '';
};

export const generateTooltipForWorkspaceDeletion = ({
  membersCount,
  isAdmin
}: {
  membersCount: number;
  isAdmin: boolean;
}): string => {
  if (!isAdmin) {
    return 'Workspace can only be deleted by an organization admin';
  }

  if (checkIsWithCollaborators(membersCount)) {
    return 'Workspace can only be deleted if it does not have any members';
  }

  return '';
};

export const generateTooltipForManageUsers = ({
  membersCount,
  canManageUsers
}: {
  membersCount: number;
  canManageUsers: boolean;
}): string => {
  if (!checkIsWithCollaborators(membersCount)) {
    return `This workspace doesn’t have any member`;
  }

  if (!canManageUsers) {
    return 'Only owners can ‘Manage users’ (remove and change their role and permissions)';
  }

  return '';
};

export const generateMoreMenuOptions = ({
  isDefault,
  membersCount,
  isAdmin,
  isMember,
  canManageUsers
}: {
  isDefault: boolean;
  membersCount: number;
  isAdmin: boolean;
  isMember: boolean;
  canManageUsers: boolean;
}): MenuOption[] => [
  {
    label: 'Make as default',
    value: MENU_VALUES.default,
    disabled: isDefault || !isMember,
    tooltipText: generateTooltipForSetDefault({ isMember, isDefault })
  },
  {
    label: 'Delete workspace',
    value: MENU_VALUES.deleteWorkspace,
    disabled: checkIsWithCollaborators(membersCount) || !isAdmin,
    tooltipText: generateTooltipForWorkspaceDeletion({
      membersCount,
      isAdmin
    })
  },
  {
    label: 'Manage users',
    value: MENU_VALUES.manageUsers,
    disabled: !checkIsWithCollaborators(membersCount) || !canManageUsers,
    tooltipText: generateTooltipForManageUsers({
      membersCount,
      canManageUsers
    })
  }
];
